import { render, staticRenderFns } from "./CreateQuestion.vue?vue&type=template&id=d7cafc86&scoped=true&"
import script from "./CreateQuestion.vue?vue&type=script&lang=js&"
export * from "./CreateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuestion.vue?vue&type=style&index=0&id=d7cafc86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cafc86",
  null
  
)

export default component.exports